<div class="reward-token-header">
    <div class="header-image-title-container">
        <div class="header-title">
            @if (isFreebetToken) {
                {{ amount | bsCurrency: prependCurrencySymbol : 2 : true : undefined : undefined : false }}
            }
            {{ tokenTitle }}
        </div>
    </div>
    <button class="close header-close" (click)="closeDialog()">
        {{ sitecoreCardDetailsConfig.messages?.closeText }}
    </button>
</div>
<div class="reward-token-card-details">
    @if (isMobileDevice) {
        <ng-scrollbar class="quick_view-token-details-scroller">
            <ng-container
                *ngTemplateOutlet="
                    tokenDetailsTemplate;
                    context: {
                        token: token,
                        tokenIcon: tokenIcon,
                        tokenType: tokenType,
                        expiresDateAndTime: expiresDateAndTime,
                        clockIcon: clockIcon,
                        isRightTimerDisable: isRightTimerDisable,
                        isExpiredToday: isExpiredToday,
                        expireTokenInDays: expireTokenInDays,
                        description: description,
                        sitecoreCardDetailsConfig: sitecoreCardDetailsConfig,
                        qualifyList: qualifyList,
                        setTokenInfoUrl: setTokenInfoUrl,
                        vipExclusiveContent: vipExclusiveContent,
                    }
                "></ng-container>
        </ng-scrollbar>
    } @else {
        <ng-container
            *ngTemplateOutlet="
                tokenDetailsTemplate;
                context: {
                    token: token,
                    tokenIcon: tokenIcon,
                    tokenType: tokenType,
                    expiresDateAndTime: expiresDateAndTime,
                    clockIcon: clockIcon,
                    isRightTimerDisable: isRightTimerDisable,
                    isExpiredToday: isExpiredToday,
                    expireTokenInDays: expireTokenInDays,
                    description: description,
                    sitecoreCardDetailsConfig: sitecoreCardDetailsConfig,
                    qualifyList: qualifyList,
                    setTokenInfoUrl: setTokenInfoUrl,
                    vipExclusiveContent: vipExclusiveContent,
                }
            "></ng-container>
    }
</div>
<div class="token-card-details-buttons">
    <div class="quick-view-buttons token-card-full-details" (click)="setTokenInfoUrl()">
        <span class="reward-token-view-more-details-btn">{{ sitecoreCardDetailsConfig.messages?.quickViewDetailsLink }}</span>
    </div>
    <div class="quick-view-buttons" (click)="betNowClick()">
        <span class="reward-token-bet-now-btn">{{ sitecoreCardDetailsConfig.messages?.betNowText }}</span>
    </div>
</div>
<ng-template
    #tokenDetailsTemplate
    let-token="token"
    let-tokenIcon="tokenIcon"
    let-tokenType="tokenType"
    let-expiresDateAndTime="expiresDateAndTime"
    let-clockIcon="clockIcon"
    let-isRightTimerDisable="isRightTimerDisable"
    let-isExpiredToday="isExpiredToday"
    let-expireTokenInDays="expireTokenInDays"
    let-description="description"
    let-sitecoreCardDetailsConfig="sitecoreCardDetailsConfig"
    let-qualifyList="qualifyList"
    let-setTokenInfoUrl="setTokenInfoUrl"
    let-vipExclusiveContent="vipExclusiveContent">
    <div class="quick_view-token-details">
        <div class="reward-type-expire-section">
            @if (isVipExclusive) {
                <div class="vip-content-container">
                    <vn-icon class="badge-vip" name="{{ vipExclusiveContent.badge }}" size="{{ vipExclusiveContent.badgeSize }}"></vn-icon>
                    <span class="exclusiveText">{{ vipExclusiveContent.badgeTitle }}</span>
                </div>
            }
            <div class="token-type-container">
                <span class="reward-token-type-icon">
                    <img width="16" height="16" [src]="tokenIcon" />
                </span>
                <span class="reward-token-type-text">{{ tokenType }}</span>
            </div>
            <div class="expires-container">
                <div class="reward-token-expire-content">
                    <span class="reward-token-expire-icon"><img [src]="clockIcon" /></span>
                    <span>{{ expiresDateAndTime }}</span>
                </div>
                @if (isRightTimerDisable) {
                    <div class="reward-token-expire-right-timer">
                        <span [ngClass]="{ 'expire-text': isExpiredToday }">{{ expireTokenInDays }}</span>
                    </div>
                }
            </div>
        </div>
        <div class="quick-view-description" [innerHTML]="description"></div>
        <div class="reward-token-card-details-qualify">
            <div class="token-card-details-qualify-header">{{ sitecoreCardDetailsConfig.messages?.quickViewQualifyTitle }}</div>
            <div class="token-card-details-qualify-list">
                <ul>
                    @for (qualify of qualifyList; track $index) {
                        <li>
                            <span [innerHtml]="qualify | trustAsHtml"></span>
                        </li>
                    }
                </ul>
            </div>
        </div>
    </div>
</ng-template>
